import httpUtils from '@/utils/http-utils';
import i18n from '@/plugins/vue-i18n';

const baseRequesterOptions = {
  baseUrl: `${window.processEnv.VUE_APP_CMS_API_BASE_URL}/attributes`,
  requesterType: 'CMS_WEB_SERVICE',
};
const attributesApiReqNotification = httpUtils.createRequester(baseRequesterOptions);
const attributesApiReqErrorHandling = httpUtils.createRequester(baseRequesterOptions, 'errorHandling');

const getRequester = (errorManagementType) => {
  if (errorManagementType === 'errorHandling') {
    return attributesApiReqErrorHandling;
  }

  return attributesApiReqNotification;
};

class AttributeApi {
  fetchAttributes(typeCode, errorManagementType) {
    return getRequester(errorManagementType)
      .get('/', {
        headers: {
          'accept-language': i18n.locale,
        },
        params: {
          typeCode,
        },
      }).then(res => res && res.data);
  }
}

export default new AttributeApi();
